import React, { memo, ChangeEvent } from 'react'
import { Checkbox } from 'transfix-ui/components/Checkbox'
import {
  ISpotBiddingRule,
  IStopSpecificDropCriteria,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IStopSpecificDropProps {
  value: RecursivePartial<IStopSpecificDropCriteria>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
}

export const StopSpecificDrop = memo<IStopSpecificDropProps>(({ onChange, value }) => {
  const { deliveryDropTrailer, pickupDropTrailer } = value

  const pickupChangeHandler = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    onChange({
      stopSpecificDropCriteria: {
        ...value,
        pickupDropTrailer: checked,
      },
    })
  }
  const deliveryChangeHandler = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    onChange({
      stopSpecificDropCriteria: {
        ...value,
        deliveryDropTrailer: checked,
      },
    })
  }

  return (
    <div className='row'>
      <div className='col-md-6 col-xs-6'>
        <Checkbox
          label='Pickup Drop Trailer'
          checked={pickupDropTrailer}
          onChange={pickupChangeHandler}
        />
      </div>
      <div className='col-md-6 col-xs-6'>
        <Checkbox
          label='Delivery Drop Trailer'
          checked={deliveryDropTrailer}
          onChange={deliveryChangeHandler}
        />
      </div>
    </div>
  )
})
